<script setup lang="ts">
import { NewsProps } from "./News.props"

defineProps<NewsProps>()
</script>

<template>
  <div class="news-wrapper h-full space-y-2 overflow-hidden md:space-y-4">
    <UtilsWrapperImage
      v-if="image"
      v-bind="image"
      :key="image.image.url"
      class="wrapper-image-16-9 flex-shrink overflow-hidden rounded-lg"
      sizes="100vw sm:100vw lg:50vw"
    />

    <p v-if="title" class="dolphin-bold md:hyppo-bold">
      {{ title }}
    </p>

    <UtilsMarkdown v-if="text" :content="text" class="beaver md:pig" />
  </div>
</template>
